import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, finalize } from 'rxjs/operators';
import { HTTPStatus } from '../HTTPStatus/httpstatus.service';

@Injectable()
export class HTTPListener implements HttpInterceptor {
  constructor(private status: HTTPStatus) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        if (event.type === 0) {
          this.status.contadorRequisitions++;
          this.status.setHttpStatus(false);
        }
        return event;
      }),
      finalize(() => {
        this.status.contadorRequisitions = this.status.contadorRequisitions <= 1 ? 0 : this.status.contadorRequisitions - 1;
        if (this.status.contadorRequisitions === 0) {
          this.status.setHttpStatus(true);
        }
      })
    );
  }
}
